import React, { useEffect } from 'react';
import CustomCode from './CustomCode';
import PreviewOptions from './PreviewOptions';
import AdvanceCustomize from './advance/AdvanceCustomize';
import { useDispatch, useSelector } from 'react-redux';
import CustomizeSection from '../../../shared/editor/CustomizeSection';
import { parseCustomizeOptions } from '../utils/customizeHelper';
import { getFontsAction, getLogosAction } from '../../LayoutEditorPage/actions/layoutEditor';
import {
  updateCustomizedAction,
  setCustomCodeAction,
  redrawProjectAction
} from '../../ChartEditorPage/actions/chartEditor';
import lang from './../../../editor/en';
import CustomizeOptions from './../meta/CustomizeOptions';
import CustomizePanelOptions from './CustomizePanelOptions';
import { setAction } from 'redux/actions/projectConfig';
import PanelContainer from 'shared/editor/generic/PanelContainer';

export default (props) => {
  const { editorConfig, isMap, chart, customCodeStr, constr, inspector } = useSelector(
    (state) => state.chartEditorPage
  );
  const { activeSection } = useSelector((state) => state.projectConfig);
  const { templateUsed, type } = useSelector((state) => state.layoutEditorPage);
  const { team } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const updateCustomizedProp = (optionProps, val, extraModulesToLoad, index) => {
    return dispatch(updateCustomizedAction({ optionProps, val, extraModulesToLoad, index }));
  };
  const getFonts = (team) => dispatch(getFontsAction({ team }));
  const getLogos = (team) => dispatch(getLogosAction({ team }));
  const setCustomCode = (customCode, skipEmit) => dispatch(setCustomCodeAction({ customCode, skipEmit }));
  const redrawProject = (_, noAnimation) => dispatch(redrawProjectAction({ noAnimation }));

  const switchActiveSection = (section) => {
    dispatch(
      setAction({
        activeSection: section
      })
    );

    if (inspector && section !== 'inspector') {
      inspector.toggleActive(false);
    }
  };

  useEffect(() => {
    if (team) {
      getFonts(team);
      getLogos(team);
    }

    return () => {
      if (inspector) inspector.toggleActive(false);
    };
  }, []);

  useEffect(() => {
    if (!props.active) {
      switchActiveSection('basic');
      if (inspector) inspector.toggleActive(false);
    }
  }, [props.active]);

  const customizeOptions = parseCustomizeOptions(CustomizeOptions);
  const isAdvanced = activeSection === 'advanced' || activeSection === 'inspector';
  return (
    <PanelContainer active={props.active} isAdvanced={isAdvanced}>
      {type === 'chart' && (
        <CustomizePanelOptions activeSection={activeSection} switchActiveSection={switchActiveSection} />
      )}

      {activeSection === 'basic' && (
        <CustomizeSection
          customizeOptions={customizeOptions}
          lang={lang}
          isMap={isMap}
          templateUsed={templateUsed}
          redrawProject={redrawProject}
          editorConfig={editorConfig}
          defaultTab={''}
        />
      )}

      {activeSection === 'customcode' && <CustomCode customCodeStr={customCodeStr} setCustomCode={setCustomCode} />}
      {activeSection === 'preview' && <PreviewOptions aggregatedOptions={props.aggregatedOptions} />}
      {isAdvanced && (
        <AdvanceCustomize
          aggregatedOptions={props.aggregatedOptions}
          constr={constr}
          chart={chart}
          updateCustomizedProp={updateCustomizedProp}
          isOpen={isAdvanced}
        />
      )}
    </PanelContainer>
  );
};
